/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/* eslint-disable import/no-unresolved, import/default */

import selfRegistrationTemplate from './self-registration.tpl.html';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function SelfRegistrationRoutes($stateProvider) {

    $stateProvider
        .state('home.selfRegistration', {
            url: '/selfRegistration',
            module: 'private',
            auth: ['TENANT_ADMIN'],
            views: {
                "content@home": {
                    templateUrl: selfRegistrationTemplate,
                    controller: 'SelfRegistrationController',
                    controllerAs: 'vm'
                }
            },
            data: {
                pageTitle: 'self-registration.self-registration'
            },
            ncyBreadcrumb: {
                label: '{"icon": "group_add", "label": "Self Registration"}'
            }
        });
}